import React, { Component } from 'react';
import "./bill.css"
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import ReactDOM from 'react-dom';
import axios from 'axios' 
const endpoint = 'https://uvune-events.herokuapp.com/upload-logo'
class Bill extends Component {

    constructor(props){
        super(props)  
        this.state ={
            showinvioce : false,
            noerorrpage :  true,
            showinviocemes : "",
            loadingInvoce : false,
            selectedFile: null,
            loaded: 0,
            
        }
        this.props.noerorrpage(this.state.noerorrpage)
    }

    
   
      handleselectedFile = event => {
        this.setState({
          selectedFile: event.target.files[0],
          loaded: 0,
        })
      }
      handleUpload = () => {
        // const data = new FormData()
        // data.append('file', this.state.selectedFile, this.state.selectedFile.name , judge ="jdue")
        const data = { 
            'uri': this.state.selectedFile,
           terms_upload: true,
        //    payment_item_id : this.props.organizer._id

        };
    
        axios
          .post(endpoint, data, {
            onUploadProgress: ProgressEvent => {
              this.setState({
                loaded: (ProgressEvent.loaded / ProgressEvent.total) * 100,
              })
            },
          })
          .then(res => {
            console.log(res.statusText)
          })
      }

    
    exportPDFWithMethod = () => {
        savePDF(ReactDOM.findDOMNode(this.grid), { paperSize: 'A4' });
    }

    exportPDFWithComponent = () => {
        this.pdfExportComponent.save();
    }

    makeSesrch=(event)=>{
        event.preventDefault()
        this.setState({
            loadingInvoce  : true
        })
        console.log("judge ", this.name.value)
         if(this.name.value === "444")
                this.setState({
                    showinvioce : true
                })
          else{
            this.setState({
                showinviocemes : "Sorry no Invoce of this data",
                loadingInvoce  : false
            })
          }     
          this.name.value ="" 
          this.setState({
            loadingInvoce  : false
        })
    }
    backToSearch=()=>{
     console.log("back")
     this.setState({
        showinvioce : false
    })
    }


    
  render() {

    return (
            <div className="Bill"> 
                
                <div className="billing-add-image-sub"> 
                    <img   src="http://res.cloudinary.com/easywaya/image/upload/v1535530819/uvunelogo1_kyi8zg.png"  />          
                </div>    
                <div className="App">
                <input type="file" name="" id="" onChange={this.handleselectedFile} />
                <button onClick={this.handleUpload}>Upload</button>
                <div> {Math.round(this.state.loaded, 2)} %</div>
              </div>
                <div className="bill-search-body">
                 {
                       this.state.showinvioce ?
                       <div>
                           <button className="button is-success" onClick={this.backToSearch}>Back to search</button>      <button className="button is-success" onClick={this.exportPDFWithComponent}>Download Pdf</button>
                       </div>   
                       :
                       <div>
                           <div className="billing-lable">
                                        Search for biller
                                </div>   
                                <form  onSubmit={this.makeSesrch}>
                                    <div className="field">
                                        *Biller reference ID
                                        <div className="control">
                                            <input className="input is-info" ref={input => this.name = input} type="text" placeholder="Enter Id sent to you"/>
                                        </div>
                                        {
                                            this.state.loadingInvoce ?
                                            <div className="level-item">
                                                <a className="button is-loading is-large is-light">Loading</a>
                                            </div> 
                                            :
                                            <button className="button is-success bill-search-butom">Enter</button>
                                        }
                                    
                                        
                                    </div>
                                </form> 

                       </div> 
                 }
                                 
                 </div>

                          <div className="bill-with-arrow-public"> 
                          {
                              this.state. showinvioce ?
                              <div>
                              <PDFExport ref={(component) => this.pdfExportComponent = component} paperSize="A4">
                                <div className="biil-invoice-body">
                                    <div className="columns">
                                    <div className="column is-three-quarters">
                                            <div className="invoice-title-body">
                                                <h2 > Invoice  #340994</h2>
                                                 <p className="invoice-title-date-para">Today</p> 
                                            </div>
                                            <hr/>
                                            <div className="bill-invoice-logo-body">
                                                <div className="bill-invoice-logo-para">
                                                    <b>Lourdes academy</b>  
                                                    <br/>
                                            
                                                    34 Otu Ansa / 5 Eka Ekong Street, Calabar.
                                                </div>
                                                <div>
                                                    <img src="https://res.cloudinary.com/vinqbot/image/upload/v1538032794/32a404620b60c71ea9116da0018aa03f8a76b93f9ba89731e9e9d323134901c2.png"  width="80"  className="image-circular"/>
                                                </div>
                                            </div>
                                        </div>
                                            <div className="column">
                                            <div className="bill-processing-body">
                                                <div className="bill-proceeing-sub">
                                                    <div className="bill-processing-light">
                                                    </div>
                                                        <p className="bill-write-up-para">Sent</p> 
                                                </div>
                                                <div className="bill-proceeing-sub">
                                                    <div className="bill-processing-light-proce">
                                                    </div>
                                                        <p className="bill-write-up-para">Processing</p> 
                                                </div>
                                                <div className="bill-proceeing-sub">
                                                    <div className="bill-processing-light-comp">
                                                    </div>
                                                        <p className="bill-write-up-para">Complete</p> 
                                                </div>
                                                
                                            </div>
                                            </div>
                                            
                                    </div>

                                    <div className="">
                                    <table className="table bill-tuition-payment-body">
                                            <thead>
                                                <tr>
                                                <th>Payment Name</th>
                                               
                                                <th><abbr title="Fullname">Fullname</abbr></th>
                                                
                                                <th>Category</th>
                                                <th>Phone</th>
                                                <th>Amouth</th>
                                                
                                            
                                                </tr>
                                            </thead>
                                            
                                            <tbody>
                                                <tr>
                                                <th>Book</th>
                                                
                                                <td>Chinye chichi</td>
                                                <td>Secondry</td>
                                                <td>0905758478</td>
                                                <td>
                                                 N  3000
                                                </td>
                                                
                                                
                                                </tr>
                                                <tr>
                                                <th>fees</th>
                                                
                                                <td>Chinye judge</td>
                                                <td>primary </td>
                                                <td>0905758478</td>
                                                <td>
                                                  N  100,000
                                                </td>
                                                
                                                
                                                </tr>
                                                <tr>
                                                <th>Stroy book</th>
                                                
                                                <td> Ezenwa nnaemeka </td>
                                                <td>primary </td>
                                                <td>0905758478</td>
                                                <td>
                                                   N 2000
                                                </td>
                                                
                                                
                                                </tr>

                                                
                                            
                                            </tbody>
                                    </table>
                                    <div className="invoice-footer-body">
                                       <div className="invoice-footer-body-sub">
                                            <b className="invoice-footer-total">Total</b>  N 1005000
                                       </div>
                                      <div className="bell-invoice-footer-seal">
                                        <img src="https://res.cloudinary.com/easywaya/image/upload/v1539260703/conpayseal_flw7th.jpg" width="85"/>
                                      </div>
                                    </div>
                                    </div>

                                </div>
                            </PDFExport>
                            <br/> 
                            <br/>
                            </div>
                           :
                           <div>
                               {this.state.showinviocemes}
                               <br/>
                               <i className="fas fa-angle-down"></i> 
                           </div>    
                      
                          }
                            

                             
                         </div>  
                   
           </div>     

    )

}





}

export default Bill;



// WEBPACK FOOTER //
// ./src/component/payment/bill.js